export default __webpack_public_path__ + "static/media/SEC.441fb227.jpg";